import cn from 'classnames'
import * as React from 'preact/compat'

import SVG from '#components/SVG'
import type { SearchItemProps } from '#components/Search/SearchPanel'

import styles from '#css/search-panel.pcss.json'
import commonCss from '#css/v9/common.pcss.json'

// noinspection ES6UnusedImports

export default ({ item }: SearchItemProps) => {
  return <>
    <a href={item.url} className={styles['material-card']} data-material-card={true}>
      <img
        alt={item.title}
        src={item.poster}
        className={styles['material-card__poster']}
        data-material-card-image={true}
      />
      <span className={styles['material-card__section']}>
        {item.dataType === 'news'
          ? <div className={cn(styles['material-card__section__icon'], styles['material-card__section__icon--news'])}>
            <SVG i={`sg-new/thunderbolt`} adaptive/>
          </div>
          : <SVG i={`v9/feed-${item.icon}`} className={styles['material-card__section__icon']}/>
        }
        {item.sectionName}
      </span>
      <h3 className={styles['material-card__title']} data-material-card-title={true}>{item.title}</h3>
      <div className={styles['material-card__info-row']}>
        <span className={styles['material-card__info']}>{item.date}</span>
        <span className={styles['material-card__comments']}>
          <SVG i='sg-new/comments' adaptive/>
          {item.comments}
        </span>
      </div>
    </a>
    <hr className={commonCss['separator']}/>
  </>
}
